const HIGH_ACTIONS = new Set([
    "task.created",
    "task.created_from_template",
    "task.status_changed",
    "task.assigned",
    "task.archived",
    "task.unarchived",
    "task.moved",
]);
const MEDIUM_ACTIONS = new Set([
    "comment.added",
    "comment.replied",
    "animal.linked",
    "animal.unlinked",
    "interaction.linked",
    "interaction.unlinked",
    "label.added",
    "label.removed",
]);
const MEDIUM_FIELD_ACTIONS = {
    "task.updated": new Set(["priority", "due_date"]),
};
const LOW_ACTIONS = new Set([
    "comment.edited",
    "comment.deleted",
    "checklist_item.added",
    "checklist_item.checked",
    "checklist_item.unchecked",
    "checklist_item.deleted",
    "checklist_item.updated",
]);
const LOW_FIELD_ACTIONS = {
    "task.updated": new Set(["title", "description"]),
};
export function getActivityImportance(action, field) {
    if (HIGH_ACTIONS.has(action))
        return "high";
    if (MEDIUM_ACTIONS.has(action))
        return "medium";
    if (field && MEDIUM_FIELD_ACTIONS[action]?.has(field))
        return "medium";
    if (LOW_ACTIONS.has(action))
        return "low";
    if (field && LOW_FIELD_ACTIONS[action]?.has(field))
        return "low";
    return "low";
}
export function getActionsForImportanceTiers(tiers) {
    const actions = [];
    const tierSet = new Set(tiers);
    if (tierSet.has("high")) {
        actions.push(...HIGH_ACTIONS);
    }
    if (tierSet.has("medium")) {
        actions.push(...MEDIUM_ACTIONS);
        actions.push("task.updated");
    }
    if (tierSet.has("low")) {
        actions.push(...LOW_ACTIONS);
        if (!tierSet.has("medium")) {
            actions.push("task.updated");
        }
    }
    return [...new Set(actions)];
}
export function getFieldsForImportanceTier(action, tiers) {
    const tierSet = new Set(tiers);
    if (action !== "task.updated")
        return null;
    const fields = [];
    if (tierSet.has("medium")) {
        fields.push(...(MEDIUM_FIELD_ACTIONS["task.updated"] ?? []));
    }
    if (tierSet.has("low")) {
        fields.push(...(LOW_FIELD_ACTIONS["task.updated"] ?? []));
    }
    return fields.length > 0 ? fields : null;
}
